const revisionsExportTour = {
  id: 'revisions-export',
  title: 'Revisions and exporting',
  summary: 'Snapshot your issues and produce a PDF.',
  // Only an open schedule sheet has these targets; the list page has none.
  match: '/dashboard/yawn/schedule/,!/dashboard/yawn/schedule/list,!/dashboard/yawn/schedule/new',
  autoStart: false,
  version: 1,
  steps: [
    {
      target: 'sheet-menu-revisions',
      title: 'Track your issues',
      body: 'Open "Revisions" to snapshot the schedule at any point.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-revision-create',
      title: 'Create a revision',
      body: 'Name it — "Draft Issue", say — give it a label like A or 1, then add it.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-revision-compare',
      title: 'Compare two revisions',
      body: 'Tick any two revisions to see exactly what changed between them.',
      tip: 'The schedule is read-only while comparing. Untick them and select "Current Changes" to edit again.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-menu-export',
      title: 'Export your schedule',
      body: 'Produce a PDF from a saved template, or build the layout from scratch.',
      placement: 'bottom',
      optional: true,
    },
  ],
};

export default revisionsExportTour;
